import React from 'react';
import { useLocation } from 'react-router-dom';
import { Theme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Button from '../../components/button/Button';
import { makeStyles } from 'tss-react/mui';
import { useNavigate } from 'react-router-dom';

const ErrorPageComponent: React.FC = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const useStyles = makeStyles()((theme: Theme) =>
    ({
        container: {
            marginTop: theme.spacing(10),
            textAlign: 'center',
        },
        errorTitle: {
            color: theme.palette.error.main,
            fontWeight: 'bold',
            marginBottom: theme.spacing(2),
        },
        errorDescription: {
            marginBottom: theme.spacing(4),
        },
        homeButton: {
            marginTop: theme.spacing(2),
        }
    }));


    const { classes } = useStyles();

    let params = new URLSearchParams(location.search);

    return (
        <Container className={classes.container}>
            <Typography variant="h4" className={classes.errorTitle}>
                Oops! Something went wrong.  Please contact support.
            </Typography>

            <Typography variant="h6" className={classes.errorDescription}>
                Error: {params.get('error') || 'Unknown Error'}
            </Typography>

            <Typography variant="h6" className={classes.errorDescription}>
                Error Description: {params.get('errorDescription') || 'No description available.'}
            </Typography>

            <Button
                variant="contained"
                color="secondary"
                className={classes.homeButton}
                onClick={() => navigate(`/`)}
            >
                Go Back to Home
            </Button>
        </Container>
    );
};

export default ErrorPageComponent;